/**
 * V1 textScanner parity (src/core/textScanner.ts:238-249): the user's font
 * size acts as a scale factor over a canvas-fitted size derived from the
 * longest line and the number of lines, so calligraphy fills the frame like
 * the V1 editor instead of rendering tiny at large canvas sizes.
 *
 * Applied at the runtime's snapshot boundary (V2Runtime.layoutSnapshot) so
 * the rasterizer itself stays a literal-size engine for layout fixtures.
 */
export function effectiveLayoutFontSize(
  text: string,
  fontSize: number,
  canvasWidth: number,
  canvasHeight: number,
): number {
  const lines = text.split('\n')
  const maxLineLength = Math.max(...lines.map((line) => line.length), 1)
  const numLines = lines.filter((line) => line.trim().length > 0).length || 1
  const fontSizeByWidth = canvasWidth / (maxLineLength * 0.8)
  const fontSizeByHeight = canvasHeight / (numLines * 1.5)
  const fitted = Math.min(fontSizeByWidth, fontSizeByHeight, canvasHeight * 0.35)
  return Math.max(40, Math.min(300, (fitted * fontSize) / 120))
}
